import type { ApiFn } from '@/api/factory/base/api';
import { useMakeQuery } from '@/api/use-make-query';
import type { Product } from '@/features/navigation/types/product';
import type { SearchResponse } from '@/navigation/types/search-response';
import { QUERY_KEYS } from './query-keys';
export const getSearchProductsQueryConfig = (query: string) => {
  const apiFn: ApiFn<SearchResponse<Product>> = (api) =>
    api.post('/search', {
      term: query,
    });

  return {
    apiFn,
    queryKey: [QUERY_KEYS.SEARCH_PRODUCTS, query],
    enabled: !!query,
  };
};

export const useSearchProductsQuery = (query: string) => {
  return useMakeQuery<SearchResponse<Product>>(
    getSearchProductsQueryConfig(query),
  );
};
